import { useContext, useState, useEffect } from "react";
import { NAME_SERVER } from "../../Utils/NAME_HOST";
import styles from "./RightBar.module.css";
import { Avatar, ConfigProvider, Spin, theme } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import UserService from "../../service/UserService";
import { useNavigate } from "react-router-dom";
import { Context } from "../..";
import { observer } from "mobx-react-lite";
import Dropdown_languages from "../UI/Dropdown_languages";
import Chat from "./components/Chat/Chat";
import { Dropdown } from "antd"
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

import Dropdown_avatars from "../UI/Dropdown_avatars/Dropdown_avatars";

function RightBar() {
    const { store } = useContext(Context);
    const navigate = useNavigate();
    const [stateDropdownAvatars, setStateDropdownAvatars] = useState(false);
    const [stateLoad, setStateLoad] = useState(true);
    const [gamesPopulation, setGamesPopulation] = useState([]);
    const [gamesLast, setGamesLast] = useState([]);


    const items = [
        {
            label: <img src={NAME_SERVER + "/assets/avatars/1.gif"} style={{ width: '100%', height: '50px', display: 'block', padding: 0 }} />,
            key: '0',
        },
        {
            label: <img src={NAME_SERVER + "/assets/avatars/1.gif"} style={{ width: '50px', height: '50px', display: 'block' }} />,
            key: '1',
        },
        {
            type: 'divider',
        },
        {
            label: '3rd menu item',
            key: '3',
        },
    ];
    const formatTime = (time) => {
        const hours = Math.floor(time / 3600);
        const minutes = Math.floor((time % 3600) / 60);
        const seconds = time % 60;

        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };
    async function start() {
        try {
            const response = await UserService.getGamesPanel();
            const data = response.data;
            if (data.status === 1) {
                setGamesPopulation(data.data.list_games_population);
                setGamesLast(data.data.list_games_last);
                setStateLoad(false);
            }
        } catch (e) {
            console.error(e);
        }
    }

    useEffect(() => {
        start();
    }, []);
    const toggleVisibility = () => {
        localStorage.setItem("rightBar",!store.visible_right_panel)

        store.set_visible_right_panel(!store.visible_right_panel);
        console.log(localStorage.getItem("rightBar"))

    };
    
    
    if ((!store.isPhone || store.state_chat)) {


        return (
            <>

                <div className={`${styles.mainCt} ${store.visible_right_panel ? styles.visible : styles.hidden}`}>
                    <div className={`${styles.toggleButton} ${store.visible_right_panel ? styles.visible : ''}`} onClick={toggleVisibility}>
                        {store.visible_right_panel ? <RightOutlined /> : <LeftOutlined />}
                    </div>
                    {stateLoad ? (
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
                    ) : (
                        <>
                            {store.user.id && (
                                <div className={styles.header}>
                                    <div className={styles.blockUser}>
                                        <div className={styles.avatarsBlock}>
                                            <Avatar onClick={() => setStateDropdownAvatars(true)} size={55} style={{ backgroundColor: store.user.avatar.color, cursor: "pointer" }}>
                                                <img src={NAME_SERVER + "/assets/" + store.user.avatar.avatar} alt="User Avatar" />
                                            </Avatar>

                                            <Dropdown_avatars state={stateDropdownAvatars} setState={setStateDropdownAvatars} />
                                        </div>

                                        <h3>{store.user.login}</h3>
                                    </div>
                                    <div>
                                        <Dropdown_languages />
                                    </div>
                                </div>
                            )}


                            <div className={styles.blockGames}>
                                <div className={styles.games}>
                                    <div className={styles.blockAuction} onClick={() => {
                                        if (store.user.id){
                                            navigate("/auction");store.set_state_chat(false)

                                        }
                                        else{
                                            store.set_modal("unreg")
                                        }
                                        }}>
                                        <div>До конца аукциона</div>
                                        <p className={styles.timeReg}>{formatTime(store.time_auction)}</p>
                                        <button className={`${styles.buttonAuction} skeleton-button`}>Участвовать</button>

                                    </div>
                                    {(gamesLast.length > 0 && !store.isPhone) && (
                                        <div className={styles.blockGame}>
                                            <h3>{store.dataLang["last_name"]}</h3>
                                            <div>
                                                {gamesLast.map(el => (
                                                    <a href={el.link} key={el.link}>
                                                        <img src={el.image} alt="Game Image" />
                                                    </a>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* <Chat /> */}
                        </>
                    )}
                </div>
            </>
        );
    }

    return null;
}

export default observer(RightBar);
